import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { stripBaseUrl } from '../../utils/routing'
import { 
    getCookie, 
    setCookie, 
    updateGtmConsent 
} from '../../utils/functions'

import { 
    CONSENT_TO_USE_COOKIES, 
    CONSENT_TYPE 
} from '../CookieBanner/CookieBanner'
import ButtonBlueSmall from '../Buttons/ButtonBlueSmall/ButtonBlueSmall'
import TitleDialog from '../TitleDialog/TitleDialog'
import Checkbox from '../Checkbox/Checkbox'

import styles from './CookieSettings.module.css'

const ESC_KEY_CODE = 27

export default class CookieSettings extends Component {
    static propTypes = {
        isOpened: PropTypes.bool.isRequired,

        onSaveSettings: PropTypes.func.isRequired,
        onCloseSettings: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            consent: {
                necessary: true,
                functional: false,
                analytics: false,
                marketing: false,
            },
        }

        this.setConsent = this.setConsent.bind(this)

        this.handleSave = this.handleSave.bind(this)
        this.handleCloseSettings = this.handleCloseSettings.bind(this)

        this.handleChangeCookieSettings = this.handleChangeCookieSettings.bind(this)
    }

    componentDidMount() {
        const cookieConsent = getCookie(CONSENT_TO_USE_COOKIES)
        if(cookieConsent) {
            const parsed = JSON.parse(cookieConsent)
            this.setConsent(parsed)
            updateGtmConsent("update", parsed)
        }

        document.body.classList.toggle('scroll-off', this.props.isOpened)

        window.addEventListener('keydown', this.handleKeyDown, true)
        window.addEventListener('click', this.handleOutsideClick, true)
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        document.body.classList.toggle('scroll-off', nextProps.isOpened)
    }

    componentWillUnmount() {
        document.body.classList.remove('scroll-off')

        window.removeEventListener('keydown', this.handleKeyDown, true)
        window.removeEventListener('click', this.handleOutsideClick, true)
    }

    handleKeyDown = (e) => {
        if (this.props.isOpened && e.keyCode === ESC_KEY_CODE) {
            this.handleCloseSettings()
            e.stopImmediatePropagation()
        }
    }

    setConsent = (consent) => {
        this.setState({ consent: {
            necessary: typeof consent.necessary !== 'undefined' ? consent.necessary : this.state.consent.necessary, 
            functional: typeof consent.functional !== 'undefined' ? consent.functional : this.state.consent.functional,
            analytics: typeof consent.analytics !== 'undefined' ? consent.analytics : this.state.consent.analytics,
            marketing: typeof consent.marketing !== 'undefined' ? consent.marketing : this.state.consent.marketing,
        }})
    }

    handleCloseSettings = () => {
        this.setConsent(this.state.consent)

        this.props.onCloseSettings()
    }

    handleChangeCookieSettings = (consentType) => {
        let newConsent = {} // { necessary: true, analytics: false, marketing: false, functional: false }

        if (consentType === 'functional') {
            newConsent = { functional: !this.state.consent.functional }
        } else if (consentType === 'analytics') {
            newConsent = { analytics: !this.state.consent.analytics }
        } else if (consentType === 'marketing') {
            newConsent = { marketing: !this.state.consent.marketing }
        } else {
            newConsent = { necessary: true }
        }
        
        this.setConsent(newConsent)
    }

    handleSave = () => {
        const newConsent = this.state.consent

        this.setConsent(newConsent)
        setCookie(CONSENT_TO_USE_COOKIES, JSON.stringify(newConsent), { maxAge: 365 })
        updateGtmConsent("update", newConsent)

        this.props.onCloseSettings()
    }

    render() {
        const cookieStyle = classNames(styles.cookieSettings, {
            [styles.isOpened]: this.props.isOpened,
        })
        return (
            <div className={cookieStyle}>
                <div className={styles.cookieSettings_overlay}></div>
                <div className={styles.cookieSettings_banner}>
                    <div className={styles.close} onClick={() => this.handleCloseSettings()}></div>
                    <div className={styles.base}>

                        <TitleDialog>Настройки файлов cookie</TitleDialog>

                        <div className={styles.base__cookieInfo}>
                            <span>Вы можете настроить использование каждой категории файлов cookie, за исключением категории «технические файлы cookie (обязательные)», 
                            для которой Ваше согласие не требуется.</span>
                            <span>Сайт tankimods.net запоминает Ваш выбор настроек на 1 год. По окончании этого периода мы снова запросим Ваше согласие. 
                            Вы вправе изменить свой выбор настроек cookie в любое время в интерфейсе Сайта.</span>
                        </div>

                        <div className={styles.base__cookieCategories}>
                            <div className={styles.category}>
                                <label className={styles.checkbox}>
                                    <Checkbox
                                        caption={null}
                                        isChecked={this.state.consent.necessary}
                                        isDisabled={true}
                                        onChange={() => {}}
                                    />
                                    <span>Технические файлы cookie (обязательные)</span>
                                </label>
                                <p>
                                    Эти cookie необходимы для корректной работы Сайта и не могут
                                    быть отключены. Они обеспечивают авторизацию и базовые функции Сайта.
                                    Мы не используем их для маркетинговых целей или отслеживания Вашей
                                    активности на других сайтах. Вы можете настроить браузер для их
                                    блокировки, но это может привести к некорректной работе Сайта.
                                </p>
                            </div>

                            <div className={styles.category}>
                                <label className={styles.checkbox}>
                                    <Checkbox
                                        caption={null}
                                        isChecked={this.state.consent.functional}
                                        isDisabled={false}
                                        onChange={() => this.handleChangeCookieSettings(CONSENT_TYPE.FUNCTIONAL)}
                                    />
                                    <span>Функциональные файлы cookie</span>
                                </label>
                                <p>
                                    Эти cookie используются для запоминания ваших предпочтений и
                                    улучшения пользовательского опыта, например, сохранения выбранного
                                    языка, региона или настроек отображения. Они делают взаимодействие с
                                    Сайтом более удобным и персонализированным. Отключение этих 
                                    cookie может повлиять на некоторые функции Сайта и удобство его
                                    использования.
                                </p>
                            </div>

                            <div className={styles.category}>
                                <label className={styles.checkbox}>
                                    <Checkbox
                                        caption={null}
                                        isChecked={this.state.consent.analytics}
                                        isDisabled={false}
                                        onChange={() => this.handleChangeCookieSettings(CONSENT_TYPE.ANALYTICS)}
                                    />
                                    <span>Аналитические файлы cookie</span>
                                </label>
                                <p>
                                    Эти cookie используются для анализа предпочтений пользователей и
                                    помогают нам улучшать работу Сайта. Они позволяют нам лучше понимать,
                                    какие разделы и функции наиболее востребованы, а также
                                    персонализировать рекомендации контента. Отключение аналитических
                                    cookie может повлиять на точность наших предложений и рекомендаций.
                                </p>
                            </div>

                            <div className={styles.category} data-type="disabled">
                                <label className={styles.checkbox}>
                                    <Checkbox
                                        caption={null}
                                        isChecked={this.state.consent.marketing}
                                        isDisabled={true}
                                        onChange={() => {}}
                                    />
                                    <span>Маркетинговые файлы cookie</span>
                                </label>
                                <p>
                                    Наш Сайт не использует данные cookie.
                                </p>
                            </div>
                        </div>
                        <div style={{display:'flex', justifyContent:'center', margin:'16px auto'}}>
                            <ButtonBlueSmall onClick={() => this.handleSave()}>Сохранить настройки cookie</ButtonBlueSmall>
                        </div>
                        <p className={styles.notice}>
                            Нажимая на кнопку «Сохранить настройки cookie», вы даёте согласие на
                            обработку cookie в соответствии с&nbsp;
                            <Link 
                                key='cookie-policy'
                                to={ stripBaseUrl('https://tankimods.net/pages/cookie-policy/') }
                                state={{ slug: 'cookie-policy', lastUrl: document.location.href }}
                                className={ classNames(styles.link, styles.isExternal) }
                                target="_blank"
                                preventScrollReset={true}
                            >Политикой использования cookie-файлов</Link>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

/*
Эти cookie используются для показа персонализированной рекламы,
анализа эффективности маркетинговых кампаний и определения ваших
интересов на основе взаимодействия с Сайтом. Отключение маркетинговых 
cookie может привести к снижению качества отображаемой рекламы.
*/